<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Sign Up</h3>
      <RegistrationForm />
    </div>
  </b-container>
</template>

<script>
import RegistrationForm from '../../components/Forms/RegistrationForm'

export default {
  name: 'AdminSignUp',
  components: { RegistrationForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/AdminSignUp.vue?17570d18